export default "__VITE_PUBLIC_ASSET__31f00c8f__"